module.exports = __webpack_public_path__ + "static/media/login.39b263bd.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/audio/notifications/login.ogg
// module id = 2775
// module chunks = 0